'use strict';

export default class Carousel {
  constructor() {
    (function ($) {
          $(".slider:not(.promotional-carousel)").slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 5000,
          });

          $(".promotional-carousel").each(function() {
            const useAutoplay = $(this).data('use-autoplay') == 'True'? true: false;
            const autoplaySpeed = $(this).data('autoplay-speed') * 1000;
            $(this).slick({
              dots: true,
              autoplay: useAutoplay,
              autoplaySpeed: autoplaySpeed,
              infinite: true,
            });
          });

          $(".slider:not(.promotional-carousel)").each(function(i, ele){
            $(ele).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                var i = (currentSlide ? currentSlide : 0) + 1;


                let textForLiveRegion = `Item ${ i } of ${ slick.slideCount }`
              $(ele).prev().html(textForLiveRegion);
            });
          })

          $(".promotional-carousel").each(function(i, ele){
            $(ele).on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
                //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
                var i = (currentSlide ? currentSlide : 0) + 1;

                let textForLiveRegion = `Item ${ i } of ${ slick.slideCount }`
              $(ele).prev().html(textForLiveRegion);
            });
          })

      }(jq14));

  }
}
